module.exports = __webpack_public_path__ + "img/tooltip_07-vallone-aure-wood-rovere-sand-milled.1ac3456b.jpg";